import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppBreadcrumbService } from '../../app.breadcrumb.service';
import { DealService } from '../../services/DealService';
import { AlertService } from '../../services/AlertService';

@Component({
  selector: 'app-deal-view',
    templateUrl: './deal-view.component.html',
    styleUrls: ['./deal-view.component.scss']
})
export class DealViewComponent implements OnInit {
    deals: any[];
    dealsFiltered: any[];
    allDeals: any[];
    dealStatuses: string[] = ['Saved', 'Draft', 'Proposed', 'Accepted', 'Closed', 'Deleted'];
    dealStatusOptions: any[] = [];
    selectedDealStatusId: number = 0;

    searchDealsDialogVisible: boolean = false;
    searchDealsDialogMessage: string = '';
    searchDealParms: any = {dealId:'', dealAddress: '', proposingBroker: '', receivingBroker:'', clientCompany: '', receivingMember: '', proposingMember: ''};

    constructor(private breadcrumbService: AppBreadcrumbService,
        private activatedRoute: ActivatedRoute,
        private dealService: DealService,
        private alertService: AlertService) { }

    ngOnInit(): void {
        this.breadcrumbService.setItems([
            this.breadcrumbService.deal,
        ]);
        this.deals = this.activatedRoute.snapshot.data['deals'];
        this.dealStatusOptions = [];
        this.dealStatusOptions.push({ label: 'Accepted', value:  3});
        this.dealStatusOptions.push({ label: 'Proposed', value: 2});
        this.dealStatusOptions.push({ label: 'Draft', value:  1});
        this.dealStatusOptions.push({ label: 'Closed', value:  4});
        this.dealStatusOptions.push({ label: 'All', value: 0 });
        this.dealStatusOnChange();
    }

    dealStatusOnChange() {
        if (this.selectedDealStatusId == 0) {
            var temp = this.deals;
            this.dealsFiltered = [...temp];
        } else {
            var temp = this.deals.filter(m => m.DealStatusID == this.selectedDealStatusId);
            this.dealsFiltered = [...temp];
        }
    }

    showSearchDealsDialog() {
        this.searchDealsDialogVisible = true;
        this.searchDealsDialogMessage = '';
        this.searchDealParms = { dealId: '', dealAddress: '', proposingBroker: '', receivingBroker: '', clientCompany: '', receivingMember: '', proposingMember: '' };
    }

    hideSearchDealsDialog() {
        this.searchDealsDialogVisible = false;
    }

    searchDeals() {
        if (this.searchDealParms.dealId.trim() == '' && this.searchDealParms.dealAddress.trim() == '' &&
            this.searchDealParms.proposingBroker.trim() == '' && this.searchDealParms.receivingBroker.trim() == '' &&
            this.searchDealParms.clientCompany.trim() == '' && this.searchDealParms.receivingMember.trim() == '' &&
            this.searchDealParms.proposingMember.trim() == '') {
            this.searchDealsDialogMessage = 'All fields are blank.'
        }
        else {
            this.dealService.SearchDeals(this.searchDealParms).subscribe(
                result => {
                    if (result != null && Array.isArray(result)) {
                        this.dealsFiltered = [...result];
                        this.hideSearchDealsDialog();
                        if (this.dealsFiltered.length > 0)
                            this.alertService.SetMessage('success', this.dealsFiltered.length + ' deals found.');
                        else
                            this.alertService.SetMessage('success', 'No deal found.');
                    }
                },
                error => {
                    this.alertService.SetMessage('error', 'There is an error while searching deals');
                }
            );
        }        
    }

    cancelSearch() {
        this.hideSearchDealsDialog();
    }   
}
